// extracted by mini-css-extract-plugin
module.exports = {"apply":"apply--1mMKJ","btns":"btns--2vrrZ","saveBtn":"saveBtn--24NmV","boxTitle":"boxTitle--14URN","info":"info--3Eig1","high":"high----PhP"};